// extracted by mini-css-extract-plugin
module.exports = {"mb20":"attestation_mb20__2gR5v","documentLink":"attestation_documentLink__1ryk1"};